import graphqlClient from "../../../apollo";

class SalesReportProvider {

    salesReport(date, branch) {
        return graphqlClient.query({
            query: require('./gql/SalesReport/salesReport.graphql'),
            variables: {date, branch},
            fetchPolicy: "network-only"
        })
    }

    deliveryCostReport(date, branch) {
        return graphqlClient.query({
            query: require('./gql/SalesReport/deliveryCostReport.graphql'),
            variables: {date, branch},
            fetchPolicy: "network-only"
        })
    }
}

export default new SalesReportProvider()


